/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const ARCHIVED_VIEWBOX_W = 20;
const ARCHIVED_VIEWBOX_H = 18;

const ARCHIVED_PATH =
  'M7.97673 10H11.9767C12.2419 10 12.4963 9.89464 12.6838 9.70711C12.8714 9.51957 12.9767 9.26522 12.9767 9C12.9767 8.73478 12.8714 8.48043 12.6838 8.29289C12.4963 8.10536 12.2419 8 11.9767 8H7.97673C7.71151 8 7.45716 8.10536 7.26962 8.29289C7.08209 8.48043 6.97673 8.73478 6.97673 9C6.97673 9.26522 7.08209 9.51957 7.26962 9.70711C7.45716 9.89464 7.71151 10 7.97673 10ZM16.9767 0H2.97673C2.27319 0.00545837 1.59395 0.258013 1.05774 0.713516C0.521532 1.16902 0.162474 1.79849 0.0433328 2.49189C-0.0758084 3.18529 0.0525466 3.89851 0.40596 4.50687C0.759374 5.11523 1.31536 5.58002 1.97673 5.82V15C1.97673 15.7956 2.2928 16.5587 2.85541 17.1213C3.41802 17.6839 4.18108 18 4.97673 18H14.9767C15.7724 18 16.5354 17.6839 17.0981 17.1213C17.6607 16.5587 17.9767 15.7956 17.9767 15V5.82C18.6381 5.58002 19.1941 5.11523 19.5475 4.50687C19.9009 3.89851 20.0293 3.18529 19.9101 2.49189C19.791 1.79849 19.4319 1.16902 18.8957 0.713516C18.3595 0.258013 17.6803 0.00545837 16.9767 0ZM15.9767 15C15.9767 15.2652 15.8714 15.5196 15.6838 15.7071C15.4963 15.8946 15.2419 16 14.9767 16H4.97673C4.71151 16 4.45716 15.8946 4.26962 15.7071C4.08209 15.5196 3.97673 15.2652 3.97673 15V6H15.9767V15ZM16.9767 4H2.97673C2.71151 4 2.45716 3.89464 2.26962 3.70711C2.08209 3.51957 1.97673 3.26522 1.97673 3C1.97673 2.73478 2.08209 2.48043 2.26962 2.29289C2.45716 2.10536 2.71151 2 2.97673 2H16.9767C17.2419 2 17.4963 2.10536 17.6838 2.29289C17.8714 2.48043 17.9767 2.73478 17.9767 3C17.9767 3.26522 17.8714 3.51957 17.6838 3.70711C17.4963 3.89464 17.2419 4 16.9767 4Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Archived / inbox tray glyph (20×18 viewBox). Color via `fill` default `currentColor`.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const ArchivedIcon = ({
  size = 20,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={Math.round((size * ARCHIVED_VIEWBOX_H) / ARCHIVED_VIEWBOX_W)}
    viewBox={`0 0 ${ARCHIVED_VIEWBOX_W} ${ARCHIVED_VIEWBOX_H}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={ARCHIVED_PATH} fill={fill} />
  </svg>
);

ArchivedIcon.propTypes = {
  ...iconPropTypes,
  /** Any valid SVG fill; default inherits text/icon color. */
  fill: PropTypes.string,
};

export { ArchivedIcon };
export default ArchivedIcon;
